import { getBrandFromURL } from "../helperFunctions";
import { VAULT_VALUES } from "./vaultValuesMock";

export const loadingStateData = () => {
    const brand = getBrandFromURL();
    if (window.location.host.includes("localhost")) {
        if (brand === "chevrolet") {
            return {
                "0": {
                    name: "Accessories",
                    columns: {
                        "0": [["Home & Offers ", "https://" + VAULT_VALUES.accessoriesChevroletPath + "/", false]]
                    },
                    location: ["https://" + VAULT_VALUES.accessoriesChevroletPath + "/", ["*"]],
                    home: ["Accessories Home", "https://" + VAULT_VALUES.accessoriesChevroletPath + "/", false, false]
                },
                "1": {
                    name: "Parts",
                    columns: {
                        "0": [["Home & Offers ", "https://" + VAULT_VALUES.partsChevroletPath + "/", false]]
                    },
                    location: ["https://" + VAULT_VALUES.partsChevroletPath + "/", ["*"]],
                    home: ["Parts Home", "https://" + VAULT_VALUES.partsChevroletPath + "/", false, false]
                },
                "2": {
                    name: "OnStar",
                    columns: {
                        "0": [
                            [
                                "Home & Offers ",
                                "https://" + VAULT_VALUES.chevroletPath + "/ownercenter/onstar/learn",
                                false
                            ]
                        ]
                    },
                    location: ["https://" + VAULT_VALUES.chevroletPath + "/", ["/ownercenter/onstar/learn"]],
                    home: ["OnStar Home", "https://" + VAULT_VALUES.chevroletPath + "/", false, false]
                }
            };
        } else if (brand === "gmc") {
            return {
                "0": {
                    name: "Accessories",
                    columns: {
                        "0": [["Home & Offers ", "https://" + VAULT_VALUES.accessoriesGMCPath + "/", false]]
                    },
                    location: ["https://" + VAULT_VALUES.accessoriesGMCPath + "/", ["*"]],
                    home: ["Accessories Home", "https://" + VAULT_VALUES.accessoriesGMCPath + "/", false, false]
                },
                "1": {
                    name: "Parts",
                    columns: {
                        "0": [["Home & Offers ", "https://" + VAULT_VALUES.partsGMCPath + "/", false]]
                    },
                    location: ["https://" + VAULT_VALUES.partsGMCPath + "/", ["*"]],
                    home: ["Parts Home", "https://" + VAULT_VALUES.partsGMCPath + "/", false, false]
                },
                "2": {
                    name: "OnStar",
                    columns: {
                        "0": [
                            ["Home & Offers ", "https://" + VAULT_VALUES.gmcPath + "/ownercenter/onstar/learn", false]
                        ]
                    },
                    location: ["https://" + VAULT_VALUES.gmcPath + "/", ["/ownercenter/onstar/learn"]],
                    home: ["OnStar Home", "https://" + VAULT_VALUES.gmcPath + "/", false, false]
                }
            };
        } else if (brand === "buick") {
            return {
                "0": {
                    name: "Accessories",
                    columns: {
                        "0": [["Home & Offers ", "https://" + VAULT_VALUES.accessoriesBuickPath + "/", false]]
                    },
                    location: ["https://" + VAULT_VALUES.accessoriesBuickPath + "/", ["*"]],
                    home: ["Accessories Home", "https://" + VAULT_VALUES.accessoriesBuickPath + "/", false, false]
                },
                "1": {
                    name: "Parts",
                    columns: {
                        "0": [["Home & Offers ", "https://" + VAULT_VALUES.partsBuickPath + "/", false]]
                    },
                    location: ["https://" + VAULT_VALUES.partsBuickPath + "/", ["*"]],
                    home: ["Parts Home", "https://" + VAULT_VALUES.partsBuickPath + "/", false, false]
                },
                "2": {
                    name: "OnStar",
                    columns: {
                        "0": [
                            ["Home & Offers ", "https://" + VAULT_VALUES.buickPath + "/ownercenter/onstar/learn", false]
                        ]
                    },
                    location: ["https://" + VAULT_VALUES.buickPath + "/", ["/ownercenter/onstar/learn"]],
                    home: ["OnStar Home", "https://" + VAULT_VALUES.buickPath + "/", false, false]
                }
            };
        } else if (brand === "cadillac") {
            return {
                "0": {
                    name: "Accessories",
                    columns: {
                        "0": [["Home & Offers ", "https://" + VAULT_VALUES.accessoriesCadillacPath + "/", false]]
                    },
                    location: ["https://" + VAULT_VALUES.accessoriesCadillacPath + "/", ["*"]],
                    home: ["Accessories Home", "https://" + VAULT_VALUES.accessoriesCadillacPath + "/", false, false]
                },
                "1": {
                    name: "Parts",
                    columns: {
                        "0": [["Home & Offers ", "https://" + VAULT_VALUES.partsCadillacPath + "/", false]]
                    },
                    location: ["https://" + VAULT_VALUES.partsCadillacPath + "/", ["*"]],
                    home: ["Parts Home", "https://" + VAULT_VALUES.partsCadillacPath + "/", false, false]
                },
                "2": {
                    name: "OnStar",
                    columns: {
                        "0": [
                            [
                                "Home & Offers ",
                                "https://" + VAULT_VALUES.cadillacPath + "/ownercenter/onstar/learn",
                                false
                            ]
                        ]
                    },
                    location: ["https://" + VAULT_VALUES.cadillacPath + "/", ["/ownercenter/onstar/learn"]],
                    home: ["OnStar Home", "https://" + VAULT_VALUES.cadillacPath + "/", false, false]
                }
            };
        }
    } else {
        if (brand === "chevrolet") {
            return {
                "0": {
                    name: "Accessories",
                    columns: {
                        "0": [["Home & Offers ", "https://usfsn_config_accessoriesChevroletPath_value/", false]]
                    },
                    location: ["https://usfsn_config_accessoriesChevroletPath_value/", ["*"]],
                    home: ["Accessories Home", "https://usfsn_config_accessoriesChevroletPath_value/", false, false]
                },
                "1": {
                    name: "Parts",
                    columns: {
                        "0": [["Home & Offers ", "https://usfsn_config_partsChevroletPath_value/", false]]
                    },
                    location: ["https://usfsn_config_partsChevroletPath_value/", ["*"]],
                    home: ["Parts Home", "https://usfsn_config_partsChevroletPath_value/", false, false]
                },
                "2": {
                    name: "OnStar",
                    columns: {
                        "0": [["Home & Offers ", "https://usfsn_config_ChevroletPath_value/", false]]
                    },
                    location: ["https://usfsn_config_ChevroletPath_value/", ["/ownercenter/onstar/learn"]],
                    home: [
                        "OnStar Home",
                        "https://usfsn_config_chevroletPath_value/ownercenter/onstar/learn",
                        false,
                        false
                    ]
                }
            };
        } else if (brand === "gmc") {
            return {
                "0": {
                    name: "Accessories",
                    columns: {
                        "0": [["Home & Offers ", "https://usfsn_config_accessoriesGMCPath_value/", false]]
                    },
                    location: ["https://usfsn_config_accessoriesGMCPath_value/", ["*"]],
                    home: ["Accessories Home", "https://usfsn_config_accessoriesGMCPath_value/", false, false]
                },
                "1": {
                    name: "Parts",
                    columns: {
                        "0": [["Home & Offers ", "https://usfsn_config_partsGMCPath_value/", false]]
                    },
                    location: ["https://usfsn_config_partsGMCPath_value/", ["*"]],
                    home: ["Parts Home", "https://usfsn_config_partsGMCPath_value/", false, false]
                },
                "2": {
                    name: "OnStar",
                    columns: {
                        "0": [["Home & Offers ", "https://usfsn_config_GMCPath_value/", false]]
                    },
                    location: ["https://usfsn_config_GMCPath_value/", ["/ownercenter/onstar/learn"]],
                    home: ["OnStar Home", "https://usfsn_config_GMCPath_value/ownercenter/onstar/learn", false, false]
                }
            };
        } else if (brand === "buick") {
            return {
                "0": {
                    name: "Accessories",
                    columns: {
                        "0": [["Home & Offers ", "https://usfsn_config_accessoriesBuickPath_value/", false]]
                    },
                    location: ["https://usfsn_config_accessoriesBuickPath_value/", ["*"]],
                    home: ["Accessories Home", "https://usfsn_config_accessoriesBuickPath_value/", false, false]
                },
                "1": {
                    name: "Parts",
                    columns: {
                        "0": [["Home & Offers ", "https://usfsn_config_partsBuickPath_value/", false]]
                    },
                    location: ["https://usfsn_config_partsBuickPath_value/", ["*"]],
                    home: ["Parts Home", "https://usfsn_config_partsBuickPath_value/", false, false]
                },
                "2": {
                    name: "OnStar",
                    columns: {
                        "0": [["Home & Offers ", "https://usfsn_config_BuickPath_value/", false]]
                    },
                    location: ["https://usfsn_config_BuickPath_value/", ["/ownercenter/onstar/learn"]],
                    home: ["OnStar Home", "https://usfsn_config_BuickPath_value/ownercenter/onstar/learn", false, false]
                }
            };
        } else if (brand === "cadillac") {
            return {
                "0": {
                    name: "Accessories",
                    columns: {
                        "0": [["Home & Offers ", "https://usfsn_config_accessoriesCadillacPath_value/", false]]
                    },
                    location: ["https://usfsn_config_accessoriesCadillacPath_value/", ["*"]],
                    home: ["Accessories Home", "https://usfsn_config_accessoriesCadillacPath_value/", false, false]
                },
                "1": {
                    name: "Parts",
                    columns: {
                        "0": [["Home & Offers ", "https://usfsn_config_partsCadillacPath_value/", false]]
                    },
                    location: ["https://usfsn_config_partsCadillacPath_value/", ["*"]],
                    home: ["Parts Home", "https://usfsn_config_partsCadillacPath_value/", false, false]
                },
                "2": {
                    name: "OnStar",
                    columns: {
                        "0": [["Home & Offers ", "https://usfsn_config_CadillacPath_value/", false]]
                    },
                    location: ["https://usfsn_config_CadillacPath_value/", ["/ownercenter/onstar/learn"]],
                    home: [
                        "OnStar Home",
                        "https://usfsn_config_CadillacPath_value/ownercenter/onstar/learn",
                        false,
                        false
                    ]
                }
            };
        }
    }
};
